export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/prime-0dff30133bdd09bcc2071162ff872924.svg";